import { getRuleList, Rule, ExportSettingsItem, getExportSettings } from 'api/rule'
import LoadingWrapper from 'components/LoadingWrapper'
import { useAlert } from 'hooks/useDialog'
import { useEffect, useState, useCallback } from 'react'
import { Routes, Route } from 'react-router-dom'

import RuleEdit from './RuleEdit'
import RuleExportSettingsList from './RuleExportSettingsList'
import RuleList from './RuleList'
import TabContent from './TabContent'

export default function RuleConfig() {
  const [loading, setLoading] = useState([false, false])
  const [rules, setRules] = useState<Rule[] | null>(null)
  const [exportSettings, setExportSettings] = useState<ExportSettingsItem[] | null>(null)
  const alert = useAlert()
  const readerHelpIconProps = {
    builderPath: '/builder/ja-JP/ocr-reader-doc/operation-rules.html#Output',
    concurPath: '/concur/ja-JP/ocr-reader-doc/operation-rules.html#Output',
    invoicePath: '/invoice/ja-JP/ocr-reader-doc/operation-rules.html#Output',
    orderFormPath: '/order-form/ja-JP/ocr-reader-doc/operation-rules.html#Output',
  }

  const reloadExportSettingsWithoutLoading = useCallback(async () => {
    setExportSettings(await getExportSettings())
  }, [])

  const reloadExportSettings = useCallback(async () => {
    setLoading((loading) => [loading[0], true])
    try {
      reloadExportSettingsWithoutLoading()
    } catch {
      alert({ message: '出力リスト取得失敗' })
    }
    setLoading((loading) => [loading[0], false])
  }, [alert, reloadExportSettingsWithoutLoading])

  const reloadRuleList = useCallback(async () => {
    setLoading((loading) => [true, loading[1]])
    try {
      setRules(await getRuleList())
    } catch {
      alert({ message: '運用ルール取得失敗' })
    }
    setLoading((loading) => [false, loading[1]])
  }, [alert])

  useEffect(() => {
    reloadRuleList()
    reloadExportSettings()
  }, [reloadRuleList, reloadExportSettings])

  return (
    <div>
      <Routes>
        <Route
          index
          element={
            <TabContent
              title="出力設定"
              readerHelpIconProps={readerHelpIconProps}
              description="OCR結果の出力設定が可能です"
            >
              <LoadingWrapper loaded={!loading[1]}>
                {exportSettings && (
                  <RuleExportSettingsList
                    list={exportSettings}
                    reloadExportSettings={reloadExportSettingsWithoutLoading}
                  />
                )}
              </LoadingWrapper>
            </TabContent>
          }
        />
      </Routes>
      <TabContent title="運用ルール設定" description="運用ルールの設定が可能です">
        <LoadingWrapper loaded={!loading[0]}>
          <Routes>
            <Route errorElement={<div />}>
              <Route index element={rules && <RuleList list={rules} />} />
              <Route path="edit" element={<RuleEdit />} />
            </Route>
          </Routes>
        </LoadingWrapper>
      </TabContent>
    </div>
  )
}
